import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Dictionary } from "src/app/store/models/common_types";
import { WatchlistService } from "../watchlist.service";
import { faSearch } from "@fortawesome/pro-light-svg-icons";

@Component({
  selector: "app-watchlist-ticker-search",
  templateUrl: "./watchlist-ticker-search.component.html",
  styleUrls: ["./watchlist-ticker-search.component.scss"],
  host: { class: "watchlist-ticker-search-host" },
  encapsulation: ViewEncapsulation.None,
})
export class WatchlistTickerSearchComponent implements OnInit {
  @Output() tickersSearchResult = new EventEmitter<any>();

  tickerSearchTextchanged: Subject<string> = new Subject<string>();
  searchResult: Array<any> = [];
  apiUrl: string = window.apiUrl;
  selectedTicker: any;
  showDropdown = false;
  queryString: string;
  api: string;
  showSelectedValue = false;
  isPaste: boolean;
  faSearch = faSearch;
  constructor(private dataService: WatchlistService) {}

  ngOnInit() {
    this.tickerSearchTextchanged
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((q) => {
        if (!this.isPaste) this.getCompanyTickerInfo(q);
      });
  }

  searchTicker(query: string) {
    this.queryString = query;
    this.tickerSearchTextchanged.next(query);
  }

  getCompanyTickerInfo(query: string): void {
    this.isPaste = false;
    if (query.trim().length) {
      this.dataService
        .getSingleTickerSearch(query)
        .subscribe((response: Dictionary<any>) => {
          if (
            response.srhData &&
            response.srhData.Company &&
            response.srhData.Company.data
          ) {
            const tickerInfoList: Array<Dictionary<string | number>> =
              response.srhData.Company.data;
            this.searchResult = tickerInfoList.map(
              (info: Dictionary<string | number | boolean>) => {
                return {
                  ticker: info.sn,
                  tickerFullName: info.n,
                  bTicker: info.bt,
                  hasError: false,
                  errorMsg: "",
                };
              },
            );
          } else {
            this.searchResult = [];
            console.error("Invalid format of response object");
          }
          this.showDropdown = true;
        });
    } else {
      this.searchResult = [];
      this.showDropdown = false;
    }
  }

  onChangeTicker(value) {
    //clear current selection after emitting
    this.tickersSearchResult.emit({ success: [value], error: [] });
    if (!this.showSelectedValue) {
      setTimeout(() => (this.selectedTicker = null), 100);
    }
    this.searchResult = [];
  }

  // For resetting/changing value from outside
  changeValue(value) {
    this.selectedTicker = value;
  }
  pasteTickers(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData("text").trim();
    pastedText = pastedText.toLowerCase().replace(/ equity/g, "");
    let delimiter = null;
    if (pastedText.includes(",")) {
      delimiter = ",";
    } else if (pastedText.includes(";")) {
      delimiter = ";";
    } else if (pastedText.includes("\t")) {
      delimiter = "\t";
    } else if (pastedText.includes("\n")) {
      delimiter = "\n";
    }
    const tickers = pastedText.split(delimiter).filter((ticker) => !!ticker);
    if (tickers.length) {
      this.isPaste = true;
      this.dataService.getTickerSearchOnPaste(tickers).subscribe(
        (resp) => {
          if (resp.data) {
            const serachList = resp.data.success.map((element) => {
              return {
                ticker: element.ticker,
                tickerFullName: element.name,
                bTicker: element.b_ticker,
                hasError: false,
                errorMsg: element.msg,
              };
            });
            const errorList = resp.data.error.map((element) => {
              return {
                ticker: element.ticker,
                tickerFullName: element.name,
                bTicker: element.b_ticker,
                hasError: true,
                errorMsg: element.msg,
              };
            });
            this.tickersSearchResult.emit({
              success: serachList,
              error: errorList,
            });
          }
          setTimeout(() => {
            this.isPaste = false;
          }, 500); // 500 -- same as debounce on type and search
        },
        (err) => {
          setTimeout(() => {
            this.isPaste = false;
          }, 500);
          throw new Error(err);
        },
      );
    }
    setTimeout(() => (this.selectedTicker = null), 10);
  }
}
